import React, { Fragment } from 'react';

import { Select, createStyles, Theme, withStyles, Grid, FormControl, MenuItem } from '@material-ui/core';

import rfcStyles from '../readyForCarriageCheck.module.css';
import commonStyles from '../../common/common.module.css';
import { SpecialOverallForm, SpecialsForm } from '../../../models/SpecialsData';

const materialStyles = (theme: Theme) =>
  createStyles({
    materialIcon: {
      fontSize: '21px',
      marginLeft: '20px',
      '&:hover': {
        cursor: 'pointer'
      }
    },
    label: {
      color: 'var(--primaryblue)',
      fontSize: '14px',
    },
    selectSpec: {
      backgroundColor: 'transparent',
      '& > div': {
        backgroundColor: 'transparent',
      }
    },
    formControl: {
      width: '50%',
    }
  });

interface SpecialChecksProps {
  classes: any;
  awbCode: string;
  specialChecks: SpecialOverallForm;
  handleChange: (event: any, type: string, id?: number) => void;
  checkElement: (check: boolean) => JSX.Element;
  onlyRead?: boolean;
  deliveredDate: string;
  disableApi: boolean;
};


const specialsChecks = (props: SpecialChecksProps) => {
  const { classes } = props;
  const specials = props.specialChecks.specials_form && props.specialChecks.specials_form.form.length ? <Fragment>
    { props.specialChecks.specials_form.form.map((special: any, index: number) => {
      return (
        <Fragment  key={ index }>
          <Grid item xs={12} sm={6} md={3}>
            <div style={ { backgroundColor: special.color, border: special.border ? `dashed 4px ${special.border}` : ''  }} 
              id={ `${index}` } onClick={ !props.disableApi ? (e) => props.handleChange(e, special.temp.length ? 'none' : 'block', index) : (e) => e.preventDefault() } 
              className={`${rfcStyles.specials} ${special.temp.length ? commonStyles.fColumn : ''} ${ props.specialChecks.special_form_data.specials_form_data[index].value ? rfcStyles.red : '' }`}
            >
              <div>{ special.name }</div>
              {special.temp.length ? <FormControl className={ classes.formControl } variant='standard'>
                <Select
                  className={ classes.selectSpec }
                  disabled={ (props.onlyRead || props.deliveredDate !== null || props.disableApi) }
                  value={ props.specialChecks.special_form_data.specials_form_data[index].temp }
                  id={ `${index}` }
                >
                  <MenuItem value="">Select Temp</MenuItem>
                  { special.temp.map((option: any, index: number) => {
                    return (
                      <MenuItem key={ index } value={ option } id={ `${index}` }>{ option }</MenuItem>
                    )
                  }) }
                </Select>
              </FormControl> : null}
            </div>

          </Grid>
        </Fragment>

      )
    }) }
    <Grid item xs={12} sm={6} md={3}><div className={`${rfcStyles.specials} ${commonStyles.fColumn } ${rfcStyles.white} ${ props.specialChecks.special_form_data.other.name.length ? rfcStyles.red : '' }`}>
      <div>Other SPLs</div>
      <FormControl className={ classes.formControl } variant='standard'>
        <Select
          value={ props.specialChecks.special_form_data.other.name }
          onChange={(e) => props.handleChange(e, 'other') }
          multiple={true}
          className={classes.selectSpec}
          disabled={ (props.onlyRead || props.deliveredDate !== null || props.disableApi) }
        >
          { props.specialChecks.specials_form.other.map((option: any, index: number) => {
            return (
              <MenuItem  key={ index } value={ option.name }>{ option.name }</MenuItem>
            )
          }) }
        </Select>
      </FormControl>
    </div>
    </Grid>

  </Fragment> : null
  return (
    <div className={ `${ commonStyles.wrapper } ${ commonStyles.tabBr } ${ rfcStyles.height200 } ${ commonStyles.fvMiddle }` }>
      <Grid container spacing={6}>
        { specials }
      </Grid>

      {/* <Grid container spacing={0} className={`${commonStyles.mb4}`}>
        <Grid item xs={12}>
          <p className={`${rfcStyles.checkTitle} ${commonStyles.mt4}`}>Activate Checklists</p>
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            value="iac_its"
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary" />}
                checkedIcon={<CheckBoxIcon color="primary" />}
                classes={{
                  root: props.classes.checkbox,
                }}
              />
            }
            label={'DGR Non Radioactive'}
            className={props.classes.completeLabel}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            value="iac_its"
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary" />}
                checkedIcon={<CheckBoxIcon color="primary" />}
                classes={{
                  root: props.classes.checkbox,
                }}
              />
            }
            label={'DGR Radioactive'}
            className={props.classes.completeLabel}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            value="iac_its"
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary" />}
                checkedIcon={<CheckBoxIcon color="primary" />}
                classes={{
                  root: props.classes.checkbox,
                }}
              />
            }
            label={'CEIV Checksheet'}
            className={props.classes.completeLabel}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            value="iac_its"
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary" />}
                checkedIcon={<CheckBoxIcon color="primary" />}
                classes={{
                  root: props.classes.checkbox,
                }}
              />
            }
            label={' Automobiles Check Sheet'}
            className={props.classes.completeLabel}
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            value="iac_its"
            control={
              <Checkbox
                name=''
                icon={<CheckBoxOutlineBlankIcon color="primary" />}
                checkedIcon={<CheckBoxIcon color="primary" />}
                classes={{
                  root: props.classes.checkbox,
                }}
              />
            }
            label={'Cool Container Checksheet'}
            className={props.classes.completeLabel}
          />
        </Grid>
      </Grid> */}
    </div>
  );
};

export default withStyles(materialStyles)(specialsChecks);